module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/checkBlueCM.7f81e3ab.svg";